'use client';

import React, { memo, useState } from 'react';
import AppIcon from './AppIcon';
import AppImage from './AppImage';

interface AppLogoProps {
  src?: string;
  iconName?: string;
  size?: number;
  priority?: boolean;
  className?: string;
  onClick?: () => void;
}

const AppLogo = memo(function AppLogo({
  src = '/assets/images/logo-greenpro.webp',
  iconName = 'SparklesIcon',
  size = 400, // Aumentei o padrão para 300px
  priority = false,
  className = '',
  onClick,
}: AppLogoProps) {
  const [imgError, setImgError] = useState(false);

  if (src && !imgError) {
    return (
      <div
        onClick={onClick}
        className={`flex items-center justify-center overflow-hidden bg-transparent ${onClick ? 'cursor-pointer hover:opacity-80' : ''} ${className}`}
        style={{
          width: `${size}px`,
          minWidth: `${size}px`, // Força o tamanho mínimo
          height: 'auto',
        }}
      >
        <AppImage
          src={src}
          alt="Logo GreenPro"
          width={size} // Carrega em dobro para manter nitidez
          height={size}
          priority={priority}
          loadingBackgroundClass="bg-transparent"
          className="w-full h-auto block object-contain"
          style={{
            maxWidth: 'none', // Remove restrições de max-width globais
            display: 'block',
          }}
          onError={() => setImgError(true)}
        />
      </div>
    );
  }

  return (
    <div className={`flex items-center justify-center ${className}`} onClick={onClick}>
      <AppIcon name={iconName} size={size} className="text-[#22c55e]" />
    </div>
  );
});

export default AppLogo;
